export function toURLSafeBase64 (plain) {
  return btoa(plain)
    .replace(/\+/g, '-') // Convert '+' to '-'
    .replace(/\//g, '_') // Convert '/' to '_'
    .replace(/=+$/, '') // Remove trailing '='
}

export function fromURLSafeBase64 (encoded) {
  const base64 = encoded
    .replace(/-/g, '+')
    .replace(/_/g, '/')

  // Pad with '=' if necessary
  const padded = base64 + '==='.slice((base64.length + 3) % 4)

  const plain = atob(padded)

  return plain
}
